import cacheLs from "../cacheLs"

export default {
  setOpenMesh (state, data) {
    state.openMesh = data
    cacheLs.set_open_mesh(data)
  }
}
